import { API_COMPOSER_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  GetApiClientResponseItem
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onSuccess?: (value?: GetApiClientResponseItem[]) => void
  onError?: (error: Error) => void
  children?: (value: GetApiClientResponseItem[]) => ReactElement
}

const GetComposerApiClientsServiceRequest = ({
  onSuccess,
  onError,
  children
}: Props) => {
  const url = `${API_COMPOSER_SERVICE}/api_clients`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetComposerApiClientsServiceRequest
